import { useAuth0 } from "@auth0/auth0-react";
import { usePermissions } from "hooks/usePermissions";
import { useSelector } from "react-redux";

const useDetermineMissingConnectors = () => {
  const { user } = useAuth0();
  const { canViewAnyConnectors } = usePermissions();
  const { sharedConnectors } = useSelector((store) => store.portal.connectors);
  const { components } = useSelector((store) => store.designer.cxfComponents);

  const updateNodesMissingConnectors = async (nodes) => {
    const connectorIds = [
      ...components
        .filter((connector) => connector.created_by_id === user.cxfUserId || canViewAnyConnectors())
        .map((ownedConnector) => ownedConnector.id),
      ...sharedConnectors
        .filter((connector) => connector.shared_user_id === user.cxfUserId)
        .map((sc) => sc.connector_id)
    ];
    const existingConnectorIds = [...new Set(connectorIds)];

    return nodes.map((n) => {
      if (n.type === "custom") {
        return {
          ...n,
          data: {
            ...n.data,
            isConnectorExist: existingConnectorIds.includes(n.data?.componentId) ? true : false
          }
        };
      }

      return n;
    });
  };

  return {
    updateNodesMissingConnectors
  };
};

export default useDetermineMissingConnectors;
